"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _dom = _interopRequireDefault(require("src/utils/dom"));
var _constants = require("libs/utils/constants");
var _url = require("libs/utils/url");
var _workspaces = require("libs/utils/workspaces");
var _routes = require("libs/utils/routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } // angular's int main()
// We import moment here because it can't be imported dynamically
// since it's an external dependency found in the `external-modules.js`.
var CONTROLLERS = ['crud', 'data', 'events', 'main', 'misc', 'orgs', 'users', 'features', 'navs', 'widgets', 'brandedApps', 'tools', 'theme-editor', 'participants'];
var DIRECTIVES = ['forms', 'tables', 'externals', 'naveditors', 'quill', 'validation', 'brandedApps', 'tools', 'theme-editor'];
var NG_DEPENDENCIES = ['backstage.templates', 'backstage.directives', 'backstage.services', 'backstage.filters', 'backstage.components', 'ngRoute', 'ngSanitize', 'ngCookies', 'smartTable.table', 'ngProgressLite', 'ngUpload', 'ngMdHtmlForm', 'ngRepeatReorder', 'ui.select2', 'textAngular'];
angular.module('backstage', (0, _lodash.chain)() // include directives, controllers
.union(DIRECTIVES.map(function (_directive) {
  return "backstage.directives.".concat(_directive);
})).union(CONTROLLERS.map(function (_ctrl) {
  return "backstage.controllers.".concat(_ctrl);
})).union(NG_DEPENDENCIES).value())

// ####
.config(/* @ngInject */["$routeProvider", "$locationProvider", "$compileProvider", function ($routeProvider, $locationProvider, $compileProvider) {
  // use HTML5 mode when routing
  $locationProvider.html5Mode(true).hashPrefix('!');

  // allow fp-asset-like URLs
  $compileProvider.imgSrcSanitizationWhitelist(/^\s*((https?|ftp|file|blob|fp-asset):|data:image\/)/);

  // SPECIAL ROUTES

  $routeProvider.when('/event/:eventId/node-offline', {
    templateUrl: '/static/partials/node-offline.html',
    path: ['event-instance-content', 'node-offline-warning']
  });
}])

// https://git.io/vo1Qv
.value('EventEmitter', function (payload) {
  return {
    $event: payload
  };
})

// ####
.run(/* @ngInject */["ACCREDITED_LINK_TOKEN_PARAM", "BLUEPRINT_FULLSCREEN_PARAM", "$rootScope", "$window", "$location", "$route", "$timeout", "$q", "$http", "ngProgressLite", "routerService", "eventService", "urlService", "userService", "blueprintService", "metricsService", "signalService", "metadataService", "i18nService", "crashReporter", function (ACCREDITED_LINK_TOKEN_PARAM, BLUEPRINT_FULLSCREEN_PARAM, $rootScope, $window, $location, $route, $timeout, $q, $http, ngProgressLite, routerService, eventService, urlService, userService, blueprintService, metricsService, signalService, metadataService, i18nService, crashReporter) {
  // we use this polyfill to make async/await work nice with angular's $digest:
  window.Promise = $q;

  // This is needed to make sure old packages will find moment when needed.
  window.moment = _momentTimezone.default;
  var eid = (0, _url.getCurrentEventIdFromUrl)();
  if (eid) {
    crashReporter.setScope({
      eid: eid
    });
  }

  /**
   * Load script with required order, with a fail safe mechanism.
   * Promise returned should in fact never fail
   * @param {...String} scripts
   * @return {Promise}
   */
  BSTG.require = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _len,
      scripts,
      _key,
      eid,
      parser,
      _iterator,
      _step,
      script,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          for (_len = _args.length, scripts = new Array(_len), _key = 0; _key < _len; _key++) {
            scripts[_key] = _args[_key];
          }
          scripts = (0, _lodash.flatten)(scripts).filter(function (script) {
            return !_constants.SOURCE_URL_BLACKLIST.includes(script);
          });
          if (scripts.length) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", $q.resolve());
        case 4:
          eid = (0, _url.getCurrentEventIdFromUrl)();
          if (eid) {
            parser = document.createElement('a');
            scripts = scripts.map(function (href) {
              parser.href = href;
              // NOTE: this was setting parser.search before but IE dun' allow that
              //       the resulting error is "The URL is invalid." - how ambiguous!
              var appendage = parser.search && parser.search.length ? "&eid=".concat(eid) : "?eid=".concat(eid);
              return parser.href + appendage;
            });
          }
          _iterator = _createForOfIteratorHelper(scripts);
          _context.prev = 7;
          _iterator.s();
        case 9:
          if ((_step = _iterator.n()).done) {
            _context.next = 21;
            break;
          }
          script = _step.value;
          _context.prev = 11;
          _context.next = 14;
          return _dom.default.loadScript(script);
        case 14:
          _context.next = 19;
          break;
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](11);
          console.error("[BSTG.require] Could not load script ".concat(script), _context.t0.message);
        case 19:
          _context.next = 9;
          break;
        case 21:
          _context.next = 26;
          break;
        case 23:
          _context.prev = 23;
          _context.t1 = _context["catch"](7);
          _iterator.e(_context.t1);
        case 26:
          _context.prev = 26;
          _iterator.f();
          return _context.finish(26);
        case 29:
          return _context.abrupt("return", Promise.resolve());
        case 30:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 23, 26, 29], [11, 16]]);
  }));
  function redirect(url) {
    (0, _lodash.get)(window.BSTG, 'services.router').redirect(url);
  }

  /* Misc configuration */

  $rootScope.APP_INSTALL_SHORTLINK_PREFIX = 'https://install.events';

  // save them for later before $route kicks in and erase them
  $rootScope.savedSearchParams = $location.search();

  /* Standard top-level document field metadata */

  $rootScope.defaultDocTemplates = {
    mail: {
      type: 'mail'
    },
    localnode: {
      instanceurl: 'http://10.79.1.1',
      deviceip: '10.79.0.0',
      deviceipcidr: '16',
      role: 'standard'
    },
    bundle: {
      bundle_type: 'feature',
      permission: 'owner_only',
      assets: []
    }
  };
  $rootScope.defaultMetadataFields = {
    org: [{
      label: 'Organization',
      field: 'name',
      validations: {
        required: true,
        pattern: '(?!.*\/).*'
      }
    }, {
      label: 'Account ID',
      field: 'sf_account_id',
      tooltip: 'The Salesforce Account ID',
      validations: {
        required: true
      }
    }],
    session_tag: [{
      label: 'Tag label',
      field: 'tag',
      default: 'General'
    }, {
      label: 'Tag color',
      field: 'tag_color',
      kind: 'colour'
    }],
    'nav-bit-ds-source': [{
      label: 'Section title',
      field: 'title',
      kind: 'choice',
      kind_options: {
        list_style: 'select'
      }
    }, {
      label: 'Icon Image',
      field: 'img',
      kind: 'external',
      kind_options: {
        type: 'icon',
        single_doc: true,
        id_field: '_id'
      }
    }],
    addUserTeamRoleForm: [{
      label: 'User\'s email address',
      field: 'email',
      tooltip: 'This is used to locate their user account in Backstage',
      attributes: {
        list: 'orgMemberEmails'
      },
      validations: {
        required: true
      }
    }, {
      label: 'Event ID',
      field: 'eventId',
      validations: {
        required: true
      }
    }, {
      label: 'Access role',
      field: 'role',
      kind: 'choice',
      kind_options: {
        values: {
          revoked: 'Revoke (remove from team)',
          manager: 'Manager',
          editor: 'Editor',
          viewer: 'Viewer'
        }
      },
      validations: {
        required: true
      }
    }]
  };

  /* Event listeners */

  // we must keep track of the previously accessed event ID here
  // as there's no way to get a hold of it in the support form controller or a resolver
  var context = null;
  var previouslyAccessedEventId = null;
  var previouslyAccessedLocationUri = null;
  function userRedirectedToInfra(url) {
    if ((0, _lodash.isString)(url)) {
      var currentUrl = (0, _url.isInfraUrl)(url);
      if (!(0, _url.isInfra)() && currentUrl) {
        window.BSTG.services.router.redirectToHome(currentUrl.pathname, currentUrl.search);
        return true;
      }
    }
    return false;
  }

  // we do all of the routey blueprinty things here
  $rootScope.$on('$locationChangeStart', function (event, next, current) {
    if (userRedirectedToInfra(current)) {
      return;
    }
    if (!ensureNavigationWarningShown()) {
      event.preventDefault();
      $rootScope.routeChangeInProgress = false;
      return;
    }
    if ($rootScope.userAllowedPaths && !$rootScope.userAllowedPaths.some(function (path) {
      return next.endsWith(path);
    })) {
      console.warn("[App] Location not allowed, preventing navigation to ".concat(next));
      return event.preventDefault();
    }
    if ((0, _lodash.isString)(current)) {
      previouslyAccessedLocationUri = current;
    }

    // navigating to another context? reload the page
    var currentContext = (0, _url.getCurrentEventIdFromUrl)() || 'global';
    if (!context) {
      context = currentContext;
    } else if (currentContext !== context) {
      redirect(current);
    }
  });
  $rootScope.$on('$routeChangeStart', function (event, next, current) {
    if (userRedirectedToInfra(current)) {
      return;
    }
    if ($rootScope.isAccountSuspended && (0, _lodash.get)(next, '$$route.originalPath') !== _constants.SUSPENDED_ROUTE) {
      $rootScope.navigateHard(_constants.SUSPENDED_ROUTE);
    }
    if ($rootScope.userAllowedPaths) {
      var currentPath = (0, _routes.buildPathFromRoute)(next);
      if (!$rootScope.userAllowedPaths.some(function (path) {
        return currentPath === path;
      })) {
        event.preventDefault();
        console.warn("[App] Route not allowed, preventing navigation to ".concat(currentPath));
        if (!current && $rootScope.userAllowedPaths.length) {
          console.warn("[App] Navigating to allowed path ".concat($rootScope.userAllowedPaths[0]));
          $rootScope.navigate($rootScope.userAllowedPaths[0]);
        }
        return;
      }
    }
    if ($location.path().match(/^\/content-hub\/.+$/)) {
      redirect($location.path());
    }
    $rootScope.routeChangeInProgress = true;
    $timeout(function () {
      if (!ngProgressLite.isRendered() && $rootScope.routeChangeInProgress) {
        ngProgressLite.start();
        return ngProgressLite.set(0.2);
      }
    }, 1000);

    // keep the previously accessed eid across route changes (used in the support form)
    if (current && current.params && current.params.eventId) {
      previouslyAccessedEventId = current.params.eventId;
    }

    // keep the fullscreen token state across route changes
    var fullscreenParams = (0, _lodash.pick)((current ? current.params : undefined) || {}, BLUEPRINT_FULLSCREEN_PARAM);
    if (!(0, _lodash.keys)(fullscreenParams).length) {
      return;
    }
    var currentSearch = $location.search();
    return $location.search(angular.extend({}, currentSearch, fullscreenParams));
  });
  $rootScope.$on('$routeChangeSuccess', function (event, current /* , previous */) {
    $rootScope.routeChangeInProgress = false;
    $timeout(function () {
      if (ngProgressLite.isRendered() && !$rootScope.routeChangeInProgress) {
        return ngProgressLite.done();
      }
    }, 200);

    // prevents a repeat show of the navigation warning message
    $rootScope.navigationWarningMessage = null;

    // tracking
    var eventId = ((current || {}).params || {}).eventId;
    var bp = (($route.current || {}).$$route || {}).blueprintMetadata;
    window.BSTG.services.track.pageChanged();
    return metricsService.track('bstg_nav', {
      module: bp ? bp.moduleKey : undefined,
      controller: bp ? bp.controllerKey : undefined,
      path: $location.$$path.replace(eventId + '/', '')
    });
  });
  $rootScope.$on('$routeChangeError', function /* event, current, previous, rejection */
  () {
    // ⚑
    // TODO: Display an error of some description
    $rootScope.routeChangeInProgress = false;
  });

  // hide the flash message after six seconds
  var flashMessageResetPromise = null;
  $rootScope.$watch('flashMessage', function (newValue) {
    if (!newValue || !newValue.message) {
      return;
    }
    if (flashMessageResetPromise) {
      $timeout.cancel(flashMessageResetPromise);
    }
    flashMessageResetPromise = $timeout(function () {
      flashMessageResetPromise = null;
      return $rootScope.unsetFlashMessage();
    }, 8000);
  });

  /* rootScope methods */

  var ensureNavigationWarningShown = function ensureNavigationWarningShown() {
    if (!(0, _lodash.isString)($rootScope.navigationWarningMessage)) {
      return true;
    }
    var ret = confirm($rootScope.navigationWarningMessage);
    if (ret) {
      $rootScope.navigationWarningMessage = null;
    }
    return ret;
  };

  // substituteParamsInRoutePath: used in <a href="">'s, so base path is included
  $rootScope.substituteParamsInRoutePath = urlService.substituteParamsInRoutePathWithBasePath;

  // navigate to a route in the current SPA instance
  $rootScope.navigate = function (path) {
    var getCurrentRoutePaths = function getCurrentRoutePaths() {
      var currentRoute = $route.current ? $route.current.$$route : undefined;
      if (!currentRoute) {
        return [];
      }
      var route = ((currentRoute.blueprintMetadata || {}).controller || {}).route || currentRoute.originalPath;
      return (0, _lodash.flatten)([route]);
    };

    // don't navigate if requested path is route of current controller
    if (getCurrentRoutePaths().includes(path)) {
      return;
    }
    if (!(0, _lodash.isString)(path)) {
      return;
    }
    for (var _len2 = arguments.length, substitutions = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      substitutions[_key2 - 1] = arguments[_key2];
    }
    return $location.path(urlService.substituteParamsInRoutePath(path, substitutions));
  };

  // navigate to a route outside the SPA
  $rootScope.navigateHard = function (path) {
    if (!ensureNavigationWarningShown()) {
      return;
    }
    // figure out our base URL in a dirty way
    var base = $('html > head > base').attr('href') || '/';
    // playing it safe with a timeout outside of $digest land

    return setTimeout(function () {
      return redirect(base + path.substring(1));
    }, 100);
  };

  // skipNavigation avoids recursion when we do an eventService.cleanScope() in the HomePageCtrl
  $rootScope.returnToHolodeck = function (skipNavigation, useRootPathInstead) {
    delete $rootScope.event;
    $rootScope.event = null;
    var redirectPath;
    if (!useRootPathInstead) {
      redirectPath = '/holodeck';
    } else {
      redirectPath = '/';
    }
    var holodeckUrl = "".concat(urlService.getTopLevelAppInstanceUrl(redirectPath));
    if (!skipNavigation) {
      $rootScope.navigateHard(holodeckUrl);
    }
  };

  // this renders nav links as .active if they are actually active
  $rootScope.isActiveRoute = function () {
    for (var _len3 = arguments.length, testNavRoutes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      testNavRoutes[_key3] = arguments[_key3];
    }
    var currentPath = (($route.current || {}).$$route || {}).path;
    if (!currentPath || !testNavRoutes || !testNavRoutes.length) {
      return false;
    }
    return !(0, _lodash.difference)(testNavRoutes, currentPath).length;
  };
  $rootScope.getGeoOptimalEventUrl = function (eventOrEventId, suffixPath) {
    if ((0, _lodash.isString)(eventOrEventId)) {
      eventOrEventId = (0, _lodash.findWhere)(($rootScope.user || {}).events, {
        _id: eventOrEventId
      });
      if (!eventOrEventId) {
        return;
      }
    }
    return eventService.generateGeoOptimalEventUrl(eventOrEventId, suffixPath);
  };
  $rootScope.getTopLevelAppInstanceUrl = urlService.getTopLevelAppInstanceUrl;
  $rootScope.setFlashMessage = function (message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
    // backwards compatibility with old angular notifications
    if (level === 'danger') {
      level = 'error';
    }
    return window.BSTG.noty.$notify({
      group: 'flashes',
      text: message,
      type: level
    });
  };
  $rootScope.unsetFlashMessage = function () {
    return delete $rootScope.flashMessage;
  };
  $rootScope.setNavigationWarningMessage = function (message) {
    return $rootScope.navigationWarningMessage = message;
  };
  $rootScope.getPageTitle = function (appName) {
    var event = $rootScope.event;
    if (!event) {
      return appName;
    }
    var eventName = eventService.getName(event);
    if (eventName) {
      return "".concat(eventName, " - ").concat(appName);
    } else {
      return appName;
    }
  };
  $rootScope.getPreviouslyAccessedEventId = function () {
    return previouslyAccessedEventId;
  };
  $rootScope.getPreviouslyAccessedLocationUri = function () {
    return previouslyAccessedLocationUri;
  };

  // FINAL INIT OF ALL SERVICES IN THE RIGHT ORDER

  // figure out what the router is able to do for us (and keep trying if this results in an error)
  var _getRouterInfoFn = function getRouterInfoFn() {
    var forceAuthStateRefreshOnSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return routerService.getRouterInfo().then(function (routerInfo) {
      $rootScope.beError = false;
      if (forceAuthStateRefreshOnSuccess) {
        // do a full reload
        return $window.location.reload();
      }
      $rootScope.routerInfo = routerInfo;
    }).catch(function (_ref2) {
      var status = _ref2.status,
        statusText = _ref2.statusText;
      $rootScope.routerInfo = null;
      $rootScope.beError = true;

      // try again in 3 seconds
      $timeout((0, _lodash.partial)(_getRouterInfoFn, true), 3000);
      console.warn('[App] Initial load failed', status, statusText);
      return $q.reject('Initial load failed');
    });
  };
  var isValidEventNode = function isValidEventNode(event) {
    var url = window.location.href;
    var node = (0, _url.getNodeName)(url);
    return Boolean(event.nodes[node]);
  };
  var redirectToRootNode = function redirectToRootNode(event) {
    var rootNode = (0, _workspaces.getRootNodeName)(event);
    var rootNodeUrl = (0, _url.getBackstageURL)(rootNode, "/event/".concat(event._id), '', 'https');
    redirect(rootNodeUrl);
  };
  var redirectHome = function redirectHome(reason, path, query) {
    var eventId = (0, _url.getCurrentEventIdFromUrl)();
    path = path || '/';
    query = query || (eventId ? "accessed_eid=".concat(eventId) : '');
    var url = window.BSTG.utils.url.getHomeUrl(path, query);
    $rootScope.navigateHard(url);
    return Promise.reject(new Error(reason));
  };
  var url = new URL(window.location.href);
  if (url.pathname.startsWith('/users/validate-account')) {
    return redirectHome('Authentication', _constants.ROUTE_VALIDATE_ACCOUNT, url.search);
  }

  // initFinished promise will resolve when everything is ready
  $rootScope.initFinished = _getRouterInfoFn().then(function () {
    // refresh the current state on startup
    // once this is done, tag root scope (we do not want to have the login shown before checking the user)
    var consumeAccreditedLinkToken = $q.resolve();
    var linkToken = $location.search()[ACCREDITED_LINK_TOKEN_PARAM];
    if (linkToken) {
      // cleanup token, it has been used
      consumeAccreditedLinkToken = $http.get("/api/v1/session/".concat(eid, "/").concat(linkToken));
    }
    window.BSTG.services.user.init(null, eid);
    return consumeAccreditedLinkToken.then(function () {
      return userService.init(eid);
    }).catch(function (error) {
      if (error.status === 401) {
        return redirectHome('Unauthorized', _constants.ROUTE_LOGIN);
      }
    }).then(function () {
      if (!$rootScope.user) return;
      var user = $rootScope.user;
      window.BSTG.services.user.init(user, eid);
      window.BSTG.services.track.setUser(user, window.BSTG.services.user.isAdmin());
      window.BSTG.services.support.setUser(user);
      window.BSTG.services.crashReporting.setUser(user);
      window.BSTG.services.template.setUser(user);
    });
  }).then(function () {
    if (!$rootScope.user) return;
    if (window.BSTG.services.router.hasSavedUrl()) {
      window.BSTG.services.router.redirectToSavedUrl();
      return;
    }
    var user = userService.getCurrentUser();
    if (!eid) {
      window.BSTG.services.blueprint.init({
        user: user,
        require: BSTG.require
      }).then(function (bp) {
        return blueprintService.init(bp);
      });
      return;
    }

    // initialize signalService only if we are in an event context
    signalService.init(eid);
    return eventService.init(eid, userService.getCurrentUser()).catch(function (error) {
      if (error.status === 403) {
        $rootScope.setNavigationWarningMessage('You are not authorized to access this event.');
        return redirectHome('Forbidden');
      }
    }).then(function () {
      var event = eventService.getCurrentEvent();
      var eventStage = (0, _lodash.get)(event, 'lifecycle.stage');
      if (!event || eventStage === 'archived' || eventStage === 'destroyed') {
        return redirectHome("Event not available - ".concat(eventStage));
      }
      if ((0, _url.isInfra)() && !isValidEventNode(event)) {
        return redirectToRootNode(event);
      }
      window.BSTG.services.documents.setTimezone(event.timezone);
      return event;
    }).then(function (event) {
      // Disallow access to the event unless it's fully initialized, cloned and operational.

      /** @type {EventLifecycleStage?} */
      var eventLifecycleStage = (0, _lodash.get)(event, 'lifecycle.stage');
      /** @type {EventLifecycleStatus?} */
      var eventLifecycleStatus = (0, _lodash.get)(event, 'lifecycle.status');
      /** @type {EventStatus?} */
      var eventStatus = (0, _lodash.get)(event, 'status');
      if (eventLifecycleStage === 'failed') {
        $rootScope.setNavigationWarningMessage('Event creation has failed. Please contact the support.');
        return redirectHome('Event not available - failed');
      }
      if (['inactive', 'restoring', 'destroyed'].includes(eventLifecycleStatus)) {
        $rootScope.setNavigationWarningMessage("You can't access event as it's ".concat(eventLifecycleStatus, "."));
        return redirectHome("Event not available - ".concat(eventLifecycleStatus));
      }
      if (eventStatus === 'creation' || eventLifecycleStatus === 'creation') {
        $rootScope.setNavigationWarningMessage("You can't access event as it's being created. Please wait.");
        return redirectHome('Event not available - creating...');
      }
      return event;
    }).then(function (event) {
      return $q.all([window.BSTG.services.blueprint.init({
        event: event,
        user: user,
        require: BSTG.require
      }), i18nService.init(), window.BSTG.services.metadata.compileMetadata(eid), metadataService.fetchAllMetadata(eid),
      // just a preload
      eventService.compilei18n(eid)]);
    }).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        blueprint = _ref4[0];
      if (userService.isFeedWall(eid) || userService.isLeaderboard(eid) || userService.isFormResults(eid)) {
        return [blueprint];
      }
      return [blueprint, window.BSTG.services.market.getInstalledPackages(eid)];
    }).then(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        blueprint = _ref6[0],
        _ref6$ = _ref6[1],
        installedPkgs = _ref6$ === void 0 ? {} : _ref6$;
      // This is used to decide what appscripts we should use in theme editor
      // When we merged `theme-editor` package back to backstage we moved these
      // appscripts to `backstage-skeleton`
      window.BSTG.skeletonVersion = installedPkgs['backstage-skeleton'];
      return blueprintService.init(blueprint, eid);
    });
  }).then(function () {
    if (!$rootScope.user) return;
    if (eid) {
      var isInvitedByLink = userService.isInvitedByLink(eventService.getCurrentEvent());
      $rootScope.hideNavs = isInvitedByLink;
      $rootScope.hideChecklist = isInvitedByLink;
    }
    var routeParams = $location.search();
    if (routeParams && routeParams.hideNavs) {
      $rootScope.hideNavs = true;
    }
    if ($rootScope.hideNavs) {
      // this is loaded in `buildMenu` and skipped if navs are hidden
      window.initNotifications();
    }
  }).then(function () {
    console.log('App Init' + (eid ? ' for event ' + eid : ' for global'));
    $route.reload();
  });
}]);